import { render, staticRenderFns } from "./loadings.vue?vue&type=template&id=00da22b8&scoped=true&"
import script from "./loadings.vue?vue&type=script&lang=js&"
export * from "./loadings.vue?vue&type=script&lang=js&"
import style0 from "./loadings.vue?vue&type=style&index=0&id=00da22b8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00da22b8",
  null
  
)

export default component.exports